import React from 'react'
import { Button } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

interface PeriodTabFooterProps {
  onSubmit: () => void
  onClear: () => void
}

const PeriodTabFooter: React.FC<PeriodTabFooterProps> = ({ onSubmit, onClear }) => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
      <Button type="text" onClick={onClear}>
        {t('periodSelect:clear')}
      </Button>
      <Button type="primary" icon={<CheckOutlined />} onClick={onSubmit}>
        {t('periodSelect:apply')}
      </Button>
    </div>
  )
}

export default PeriodTabFooter
